import {IFlightCII, IRadar} from '@/types/radar';
import {ISectorCII} from '@/types/sector';
import {createSlice} from '@reduxjs/toolkit';
import moment from 'moment';

interface EmissionState {
  radars: IRadar[];
  selectedRadar: IRadar | null;
  isUtc: boolean;
  flightCII: IFlightCII | null;
  sector: string | null;
  detailSector: ISectorCII | null;

  radarHistory: Record<string, string>;
  sectorHistory: Record<string, string>;
}

const initialState: EmissionState = {
  radars: [],
  selectedRadar: null,
  flightCII: null,
  isUtc: false,
  sector: null,
  detailSector: null,
  radarHistory: {},
  sectorHistory: {}
};

const emissionSlice = createSlice({
  name: 'emissionSlice',
  initialState,
  reducers: {
    setRadars: (state, action: {payload: any}) => {
      state.radars = action.payload;
    },
    setIsUtc: (state, action: {payload: boolean}) => {
      state.isUtc = action.payload;
    },
    setSelectedRadar: (state, action: {payload: IRadar | null}) => {
      state.selectedRadar = action.payload;
      if (action.payload) {
        state.radarHistory[action.payload.searchString] =
          moment().toISOString();
      }
    },
    setFlightCII: (state, action: {payload: IFlightCII | null}) => {
      state.flightCII = action.payload;
    },
    setSector: (state, action: {payload: string | null}) => {
      state.sector = action.payload;
      if (action.payload) {
        state.sectorHistory[action.payload] = moment().toISOString();
      }
    },
    setDetailSector: (state, action: {payload: ISectorCII | null}) => {
      state.detailSector = action.payload;
    }
  }
});

export const {
  setRadars,
  setIsUtc,
  setSelectedRadar,
  setFlightCII,
  setSector,
  setDetailSector
} = emissionSlice.actions;
export default emissionSlice.reducer;
